"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Instagram, Linkedin, Twitter } from "lucide-react";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    const fallbackLinks = [{
      label: "Roof Repair",
      href: "/roofrepair"
    }, {
      label: "Roof Replacement",
      href: "/roofreplacement"
    }, {
      label: "Siding Installation",
      href: "/sidinginstallatio"
    }, {
      label: "Gutter Installation",
      href: "/gutterinstalation"
    }];
    return <ul className="flex flex-col gap-3">
        {fallbackLinks.map((item, i) => <li key={i} data-index={i}>
            <Link to={item.href} className="font-default text-sm text-foreground hover:text-primary transition-all">
              {item.label}
            </Link>
          </li>)}
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="font-default text-sm text-foreground hover:text-primary transition-all">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function FooterAndLegal() {
  const resourcesLinks = [{
    label: "About Us",
    href: "/AboutPage"
  }, {
    label: "Our Blog",
    href: "/BlogPage"
  }, {
    label: "FAQs",
    href: "/FAQPage"
  }];
  const serviceLinks = [{
    label: "Roof Repair",
    href: "/RoofRepairPage"
  }, {
    label: "Roof Replacement",
    href: "/RoofReplacementPage"
  }, {
    label: "Siding Installation",
    href: "/SidingReplacementPage"
  }, {
    label: "Gutter Installation",
    href: "/GutterInstallationPage"
  }];
  {}
  return <section data-section-id="239440" id="footer" className="dark w-full flex flex-col bg-background text-foreground">
      <div className="bg-background py-16 px-8">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          
          <div className="flex flex-col gap-6">
            <h3 className="font-default text-lg font-bold text-foreground uppercase tracking-tight">Company</h3>
            <MenuProvider menu_id="43">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div className="flex flex-col items-center justify-center gap-8">
        <div className="w-1/3 hidden md:flex items-center gap-6">
          <Link to="/" className="block group">
            <img src="https://liberal-koi.10web.cloud/wp-content/uploads/2026/05/LOGO-2.png" alt="Eagle Exteriors" className="h-12 w-auto object-contain" loading="lazy" />
          </Link>
          
        </div>
          {}
          </div>

          <div className="flex flex-col justify-center">
            <p className="font-default text-sm text-foreground uppercase leading-relaxed text-center md:text-left">
              Expert roofing and exterior solutions. We provide roof repair, roof replacement, siding installation, gutter systems, and storm damage services throughout Maryland and Northern Virginia. Protecting homes with integrity and expert craftsmanship.{" "}
             
            </p>
          </div>

          <div className="flex flex-col gap-6 md:items-end">
            <div className="flex flex-col gap-6 w-full md:w-auto">
              <h3 className="font-default text-lg font-bold text-foreground uppercase tracking-tight">Resources</h3>
              <ul className="flex flex-col gap-3">
                {resourcesLinks.map((link, i) => <li key={i} data-index={i}>
                    <Link to={link.href} className="font-default text-sm text-foreground hover:text-primary transition-all">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
             
            </div>
          </div>

        </div>
      </div>

      <div className="bg-primary py-4 px-8">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8">
          <p className="font-default text-xs text-primary-foreground font-semibold uppercase tracking-wider text-center">Need help now? Call (240) 899-1278 or get free estimate  </p>
          <p className="font-default text-xs text-primary-foreground font-semibold uppercase tracking-wider text-center">© 2026 EAGLE EXTERIORS. ALL RIGHTS RESERVED.</p>
          <div className="flex items-center gap-6">
            <Link to="privacy-policy" className="font-default text-xs text-primary-foreground font-semibold uppercase tracking-wider hover:opacity-80 transition-all">
              Privacy Policy
            </Link>
            <Link to="#terms-of-use" className="font-default text-xs text-primary-foreground font-semibold uppercase tracking-wider hover:opacity-80 transition-all">
              Terms of Use
            </Link>
          </div>
        </div>
      </div>
    </section>;
}